import { render, staticRenderFns } from "./EditorTeam.vue?vue&type=template&id=19a7192e&scoped=true"
import script from "./EditorTeam.vue?vue&type=script&lang=js"
export * from "./EditorTeam.vue?vue&type=script&lang=js"
import style0 from "./EditorTeam.vue?vue&type=style&index=0&id=19a7192e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a7192e",
  null
  
)

export default component.exports